import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { MdKeyboardArrowDown } from "react-icons/md";
import "./nav-dropdown.css";
import { Backdrop } from "@material-ui/core";
import { CreateList } from "../create-list";

const NavDropdownList = () => {
  const [visible, setVisibility] = useState(false);
  const [createList, setCreateList] = useState(false);

  const listShortcuts = JSON.parse(
    localStorage.getItem("appearance")
  ).listShortcuts;
  return (
    <div
      id="nav-list-container"
      onMouseEnter={() => setVisibility(true)}
      onMouseLeave={() => setVisibility(false)}
    >
      <div id="nav-item-container">
        <h3>Lists</h3>
        <MdKeyboardArrowDown className="arrow-down" />
      </div>
      {visible && (
        <div id="dropdown-list">
          {listShortcuts.map((shortcut) => {
            const link = "/dashboard/lists/" + shortcut.listId;
            return (
              <div>
                <Link to={link}>
                  <h3 className="nav-list-item">{shortcut.title}</h3>
                </Link>
              </div>
            );
          })}
          <div className="nav-last-item">
            <Link to="/dashboard/lists">
              <button className="extra-nav-btn">All lists</button>
            </Link>
            <BsFillPlusCircleFill
              onClick={() => setCreateList(true)}
              className="nav-add-btn"
            />
          </div>
        </div>
      )}
      {createList && (
        <Backdrop open="open" id="backdrop">
          <CreateList setCreateList={setCreateList} />
        </Backdrop>
      )}
    </div>
  );
};

export default NavDropdownList;
